import { TargetAndTransition, Variants } from 'motion/react';

export const fadeContainerVariants: Variants = {
    initial: {},
    animate: ({ staggerChildren = 0.3 }: { staggerChildren?: number } = {}) => ({
        transition: { staggerChildren },
    }),
    exit: ({ staggerChildren = 0.1 }: { staggerChildren?: number } = {}) => ({
        transition: { staggerChildren, staggerDirection: -1 },
    }),
};

export const fadeVariants: Variants = {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 0.5, ease: 'easeOut' } },
    exit: { opacity: 0, transition: { duration: 0.3, ease: 'easeIn' } },
};

export const fadeZoomVariants: Variants = {
    initial: ({ scale = 0.9 }: { delay?: number; scale?: number } = {}) => ({
        opacity: 0,
        scale,
    }),
    animate: ({ delay = 0 }: { delay?: number; scale?: number } = {}) => ({
        opacity: 1,
        scale: 1,
        transition: { duration: 0.4, ease: 'easeOut', delay },
    }),
    exit: { opacity: 0, scale: 0.9, transition: { duration: 0.2, ease: 'easeIn' } },
};

export const springPopVariants: Variants = {
    initial: { opacity: 0, scale: 0.6 },
    animate: (custom?: Partial<TargetAndTransition>) => ({
        opacity: 1,
        scale: 1,
        ...custom,
        transition: { type: 'spring', stiffness: 400, damping: 20, ...custom?.transition },
    }),
};

export const shakeVariants: Variants = {
    initial: { x: 0 },
    animate: { x: [0, -8, 8, -8, 8, -4, 4, 0], transition: { duration: 0.4, ease: 'easeInOut' } },
};

export const fadeZoomContainerVariants: Variants = {
    initial: {},
    animate: {
        transition: { staggerChildren: 0.15 },
    },
    exit: {
        transition: { staggerChildren: 0.2, staggerDirection: -1 },
    },
};
